export default "__VITE_ASSET__DJX2RyE$__"